import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { GroupPurchasePricing } from 'frontend/types/premium/group-plans';

type OptionalGroupPurchasePricing = GroupPurchasePricing | null;

const groupPurchasePricing: Module<OptionalGroupPurchasePricing, RootState> = {
  namespaced: true,
  state: null,
  mutations: {
    setValue(state: OptionalGroupPurchasePricing, value: OptionalGroupPurchasePricing) {
      Object.assign(state, value);
    },
  },
};

export default groupPurchasePricing;
